// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__293TU","upload":"Small_upload__1Gh9Y","imageWrap":"Small_imageWrap__3Dcz4","removeBtn":"Small_removeBtn__2gf5W"};